import { FC, useMemo } from "react";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { scoreToDisplayStars } from "../../../config/rating";
import { resolveWidgetV2Style } from "./widgetV2Styles";

const LOGO_MARK = `${process.env.PUBLIC_URL}/images/logos/logo-mark.webp`;

/** Micro Strip (v2) — admin-preview-only. Real embed markup lives in widget-v2.js (renderStrip). */
const WidgetTemplate16: FC<IWidgetTemplate> = ({ company, score, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("strip", style);
  const payload = useMemo(() => ({ companyId, widgetId: 16 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-strip`,
    [companyId],
  );
  const reviewsStr = (score?.totalReview ?? 0).toLocaleString();

  if (resolvedStyle === "text-only") {
    return (
      <div className="text-center" style={{ fontSize: 12, color: "#6b6b85" }}>
        <a
          href={profileUrl}
          target="_blank"
          rel="noopener"
          onClick={() => ReachClick(payload)}
          style={{ textDecoration: "none", color: "#6b6b85" }}
        >
          Rated <b style={{ color: "#1c1c2e" }}>{scoreToDisplayStars(score?.score ?? 0)}/5</b> on{" "}
          <b style={{ color: "#006bf1" }}>TrustFinance</b> · {reviewsStr} verified reviews
        </a>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center">
      <a
        href={profileUrl}
        target="_blank"
        rel="noopener"
        onClick={() => ReachClick(payload)}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          border: "1px solid #e7e8ec",
          borderRadius: 999,
          padding: "8px 16px",
          background: "#fff",
          textDecoration: "none",
          fontSize: 12,
        }}
      >
        <img src={LOGO_MARK} alt="TrustFinance" width={16} height={16} />
        <b style={{ color: "#006bf1" }}>TrustScore {score?.score}/100</b>
        {resolvedStyle === "with-cta" ? (
          <span style={{ color: "#006bf1", fontSize: 11.5, fontWeight: 600 }}>Read reviews →</span>
        ) : (
          <span style={{ color: "#6b6b85" }}>· {reviewsStr} reviews</span>
        )}
      </a>
    </div>
  );
};

export default WidgetTemplate16;
